const ARS = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 2,
});
export function formatearMonto(valor) {
    if (valor === null || valor === undefined || valor === '')
        return '—';
    const num = typeof valor === 'string' ? Number(valor) : valor;
    if (Number.isNaN(num))
        return '—';
    return ARS.format(num);
}
export function formatearFecha(iso) {
    if (!iso)
        return '—';
    // Caso fecha sola (YYYY-MM-DD): la formateamos sin pasar por Date para
    // evitar el corrimiento de zona horaria (UTC vs local) que rota el día.
    const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (soloFecha) {
        const [, y, m, d] = soloFecha;
        return `${d}/${m}/${y}`;
    }
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '—';
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    return `${dia}/${mes}/${d.getFullYear()}`;
}
export function formatearHora(iso) {
    if (!iso)
        return '—';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return '—';
    return d.toLocaleTimeString('es-AR', {
        hour: '2-digit',
        minute: '2-digit',
    });
}
export function formatearFechaHora(iso) {
    if (!iso)
        return '—';
    return `${formatearFecha(iso)} ${formatearHora(iso)}`;
}
/**
 * Porcentaje legible: `15%` para enteros, `15,5%` con coma decimal cuando lo
 * tiene. Acepta string o number. Retorna `—` si no es número finito.
 */
export function formatearPct(v) {
    if (v == null || v === '')
        return '—';
    const n = typeof v === 'string' ? Number(v) : v;
    if (!Number.isFinite(n))
        return '—';
    return Number.isInteger(n) ? `${n}%` : `${n.toString().replace('.', ',')}%`;
}
export function iniciales(nombre) {
    if (!nombre)
        return '?';
    const partes = nombre.trim().split(/\s+/);
    const primera = partes[0]?.[0] ?? '';
    const segunda = partes[1]?.[0] ?? '';
    return (primera + segunda).toUpperCase() || '?';
}
